import React from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BentoIcon from '../BentoIcon';

interface OutlinedTextFieldProps {
  id?: string;
  name?: string;
  value?: string | number | null;
  className?: string;
  length?: number;
  type?: string;
  select?: boolean;
  label?: string;
  inputProps?: object;
  isClearable?: boolean;
  tooltipText?: string; // New prop for tooltip text
  setValue?: (value: string) => void;
  children?: any;
  onChange?: (event: any) => any;
  [key: string]: any; // Allow additional props
}

export default function OutlinedTextField({
  value,
  className = '',
  length = 100,
  type = 'text',
  inputProps = {},
  isClearable = false,
  setValue = () => {},
  tooltipText,
  ...rest
}: OutlinedTextFieldProps) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      autoComplete="off"
      value={value}
      slotProps={{
        htmlInput: {
          maxLength: length,
        },
        input: {
          type,
          endAdornment:
            isClearable && !!value ? (
              <IconButton onClick={() => setValue('')} style={{ marginRight: -10 }}>
                <BentoIcon name="xmark" />
              </IconButton>
            ) : !value && tooltipText ? (
              <Tooltip title={tooltipText} placement="top">
                <span>
                  <IconButton size="small" disabled>
                    <BentoIcon color="primary" name="circle-question" variant="solid" />
                  </IconButton>
                </span>
              </Tooltip>
            ) : null,
          ...inputProps,
        },
      }}
      className={className}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      {...rest}
    />
  );
}
